import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const HideIcon = (props: IconProps) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      color="blue.600"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="m11.8 9 3.2 3.2V12a3 3 0 0 0-3-3h-.2zm-4.3.8 1.6 1.6-.1.6a3 3 0 0 0 3 3h.7l1.5 1.5a5 5 0 0 1-2.2.5 5 5 0 0 1-5-5c0-.8.2-1.5.5-2.2zM2 4.3l2.3 2.2.4.5c-1.6 1.3-3 3-3.7 5a11.8 11.8 0 0 0 15.4 6.7l.4.4 3 2.9 1.2-1.3L3.3 3 2 4.3zM12 7a5 5 0 0 1 5 5c0 .6-.1 1.3-.4 1.8l3 3c1.5-1.3 2.7-3 3.4-4.8A11.8 11.8 0 0 0 8 5.2l2.2 2.1A5 5 0 0 1 12 7z"
        />
      </g>
    </Icon>
  );
};

export default HideIcon;
